import { render, staticRenderFns } from "./RcpyL.vue?vue&type=template&id=1566bf8c"
import script from "./RcpyL.vue?vue&type=script&lang=js"
export * from "./RcpyL.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports